module.exports = __webpack_public_path__ + "img/LNB_consult.4ce41fac.svg";